import React from "react";
import PaymentCycleItemManagePage from "./PaymentCycleItemManagePage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface PaymentCycleItemManagePageContainerProps extends RouteProps, withValidUserRoleProps {}

const PaymentCycleItemManagePageContainer = (props: PaymentCycleItemManagePageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <PaymentCycleItemManagePage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(PaymentCycleItemManagePageContainer);
